import * as React from 'react';

import FormSchema, { Field, Group } from '@ui-library/formSchema';
import { get } from 'lodash';
import { FixMe } from '@utils/types';
import { warehouseList as formTemplatesMap } from '../warehouseSourceList/warehouseSettings';
import { Container } from './styles';

interface IWarehouseSettingsProps {
  onSettingsChange?: (accountId: string, accountInfo: FixMe, isValid: boolean) => void;
  initialSettings?: FixMe;
  disabled?: boolean;
  sourceDefinition: FixMe;
}

export default class WarehouseSettings extends React.Component<IWarehouseSettingsProps, FixMe> {
  constructor(props: IWarehouseSettingsProps) {
    super(props);
    this.state = {
      settings: props.initialSettings,
    };
  }

  getFormTemplate() {
    return (formTemplatesMap as { [key: string]: FixMe })[
      this.props.sourceDefinition.name.toUpperCase()
    ];
  }

  public onSettingsChange = (settings: FixMe, isValid: boolean) => {
    const { onSettingsChange, sourceDefinition } = this.props;
    const formTemplate = this.getFormTemplate()[0];
    const secretFields = formTemplate?.secretFields;
    const nameField = formTemplate?.nameField;

    let accountInfo = {
      options: {} as FixMe,
      secret: {} as FixMe,
      name: '',
      role: sourceDefinition.name,
    };
    accountInfo = Object.keys(settings).reduce((accum, key) => {
      const currentValue = settings[key];

      if (key === nameField) {
        accum.name = currentValue;
      }
      if (secretFields && secretFields.includes(key)) {
        accum.secret[key] = currentValue;
      } else if (key !== 'rudder_account_name') {
        accum.options[key] = currentValue;
      }
      return accum;
    }, accountInfo);

    if (onSettingsChange) {
      onSettingsChange('', accountInfo, isValid);
    }
  };

  public onChange = (settings: FixMe, isError: boolean) => {
    const { disabled } = this.props;

    const fields = this.getFormTemplate().reduce(
      (acc: Field[], group: Group) => acc.concat(group.fields),
      [],
    );
    const newSettings = settings;
    let isValid = !isError;
    /* for each field get value of obtainValueFromField.key, if exists,
    from value of obtainValueFromField.name in settings
    and set the value of the field in settings */
    if (!disabled) {
      fields.forEach((field: Field) => {
        try {
          const { obtainValueFromField, value } = field;
          if (obtainValueFromField) {
            const primaryFieldValue = JSON.parse(get(newSettings, obtainValueFromField.name, ''));
            newSettings[value] = get(primaryFieldValue, obtainValueFromField.key, '');
          }
        } catch (err) {
          newSettings[field.value] = '';
        }
      });
      isValid = isValid && FormSchema.validate(newSettings, fields);
    }

    this.setState(
      (prevState: FixMe) => ({
        settings: {
          ...prevState.settings,
          ...newSettings,
        },
      }),
      () => this.onSettingsChange(this.state.settings, isValid),
    );
  };

  public render() {
    const { disabled } = this.props;

    const { settings } = this.state;
    const defaultFormTemplate = this.getFormTemplate();
    return (
      <Container className="p-t-lg p-b-lg wh_source__credential_form" style={{ width: '475px' }}>
        <FormSchema
          schema={defaultFormTemplate}
          onChange={this.onChange}
          initialSettings={settings}
          disabled={!!disabled}
          validate={false}
        />
      </Container>
    );
  }
}
